import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'
import AppConfig from 'Constants/AppConfig';
import Vue from 'vue'

export const BugsnagConfig = {
  configure() {
    Bugsnag.start({
      apiKey: AppConfig.bugsnagApiKey,
      plugins: [new BugsnagPluginVue(Vue)],
      releaseStage: process.env.VUE_APP_RELEASE_STAGE
    })
  }
}